/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Occasion that may propose a connection edge.
 */
export type ConnectionOccasionType = (typeof ConnectionOccasionType)[keyof typeof ConnectionOccasionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectionOccasionType = {
  gss_slot: 'gss_slot',
} as const;
